// src/components/Login.js
import React, { useState } from "react";
import { setToken } from "../utils/auth";
import { useParams, Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createUserAccount } from "../services/apiService";
import { Form, InputGroup, FormControl } from 'react-bootstrap';
import SideBar from "./SideBar";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [registratioinResult, setRegistrationResult] = useState(false);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  async function registerUser(email, password) {
    try {
      let res = await createUserAccount(email, password);
      if (res.result == "success") {
        toast.success(res.message);
        setRegistrationResult(true);
      } else if (res.result == "error") {
        toast.error(res.message);
        return false;
      }
    } catch (error) {
      toast.error("Error fetching users:" + error);
      return false;
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (email == "" || password == "") {
      toast.error("Please specify email id & password !");
      return false;
    }

    registerUser(email, password);
  };

  return (
    <>
      <div
        className={`container dashboard ${sidebarOpen ? "sidebar-open" : ""}`}
      >
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
          <div className="container">
            <a href="#home" className="logo">
              Casual <span>Tech</span>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNav"
              aria-controls="mainNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={toggleSidebar}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
        </nav>

        {/* Body */}
        <div className="dashboard-body">
          {/* Sidebar */}
          <SideBar />

          {/* Main */}
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            {registratioinResult == "" ? (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                  <h4>Website Builder - Signing up</h4>
                </div>
                <div className="col-sm-6 mb-3 mt-3">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3 mt-3">
                      <label htmlFor="exampleInputEmail1" className="mb-3 mt-3">
                        Email address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 mt-3">
                      <label
                        htmlFor="exampleInputPassword1"
                        className="mb-3 mt-3"
                      >
                        Password
                      </label>
                      <InputGroup>
                        <FormControl
                          type={passwordVisible ? "text" : "password"}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <InputGroup.Text
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          {passwordVisible ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-eye"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-eye-slash"
                              viewBox="0 0 16 16"
                            >
                              <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                              <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                              <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                            </svg>
                          )}
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </form>
                </div>
              </>
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="alert alert-success" role="alert">
                    <p>Success.</p>
                    <p>Your account has been created, successfully.</p>
                    <Link to={`/login`} className="btn btn-info card-link">
                      Login Now
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>

        {/* Footer */}
        <footer className="dashboard-footer">
          © 2025 Casual Tech. All rights reserved.
        </footer>
      </div>
    </>
  );
};

export default SignUp;
